export default {
  toast_messages: {
    google_review_uploaded: 'Recenzia ta a fost verificată cu succes. Ai câștigat {{points}} pct 😉',
  },
};
